import { chain } from "@/mocks/feed";
import SectionHeading from "./SectionHeading";

const stateStyle: Record<string, string> = {
  进行中: "bg-accent-500 text-foreground-950",
  已核实: "bg-primary-500 text-background-50",
  已归档: "bg-secondary-100 text-secondary-800",
};

const iconMap: Record<number, string> = {
  0: "ri-flag-line",
  1: "ri-fire-line",
  2: "ri-message-3-line",
  3: "ri-zoom-in-line",
  4: "ri-checkbox-circle-line",
};

export default function TimelineSection() {
  return (
    <section id="chain" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          accent
          eyebrow="完整事件链 · 深度追踪"
          title={chain.title}
          desc={chain.intro}
        />

        <div className="mt-10 grid gap-8 lg:grid-cols-12">
          <ol className="relative lg:col-span-8">
            <span className="absolute left-[19px] top-3 bottom-3 w-px bg-background-300"></span>
            {chain.stages.map((s, i) => (
              <li key={i} className="relative flex gap-5 pb-7 last:pb-0">
                <span className="z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-4 border-background-100 bg-primary-500 text-background-50">
                  <i className={`${iconMap[i]} text-base`} aria-hidden="true"></i>
                </span>
                <div className="flex-1 rounded-xl border border-background-200 bg-background-50 p-4">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <span className="text-xs font-semibold uppercase tracking-wide text-primary-600">
                      {s.stage} · {s.time}
                    </span>
                    <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${stateStyle[s.state] || "bg-secondary-100 text-secondary-800"}`}>
                      {s.state}
                    </span>
                  </div>
                  <h3 className="mt-1.5 text-base font-bold text-foreground-950">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-4" aria-label="事件链说明">
            <div className="flex flex-col gap-4 lg:sticky lg:top-24">
              <div className="rounded-2xl border border-accent-300 bg-accent-100/60 p-5">
                <span className="inline-flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <i className="ri-time-fill text-accent-700" aria-hidden="true"></i>
                  持续更新中
                </span>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                  这条事件链仍在发酵，吃瓜前线会随最新进展持续补充归档。想追完整，随时回刷本页即可看到新增环节。
                </p>
              </div>
              <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
                <h3 className="text-sm font-bold text-foreground-950">为什么需要完整事件链</h3>
                <ul className="mt-3 space-y-2.5 text-sm text-foreground-600">
                  {[
                    "避免断章取义，看清前后文",
                    "区分已核实与待核实信息",
                    "把不同来源拼回同一脉络",
                  ].map((t) => (
                    <li key={t} className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" aria-hidden="true"></i>
                      {t}
                    </li>
                  ))}
                </ul>
                <a
                  href="#faq"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("faq")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
                >
                  关于事件核对 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}